import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { BodyWhite } from '../../components/templates/BodyWhite';
import Toast from '../../components/Toasts/Toast';
// import LoginForm from '../../components/Inputs/Login/LoginForm';
import FormField from '../../components/Inputs/Login/FormField';
import PasswordField from '../../components/Inputs/Login/PasswordField';
import { authenticationService } from '../../services/authentication.service';
import { withRouter } from 'react-router-dom';
import {
  isPontoAtendimento,
  isSudo,
} from '../../helpers/permissions.helper';

type Props = {
  dispatch: any,
  loggingIn: boolean,
  loggedIn: boolean,
  alert: any,
  fieldMessage: any,
};

class IndexContent extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      usernameValue: '',
      passwordValue: '',
      nameValue: '',
      viewCadastro: false,
      termo: false,
      checkAceite: true,
    };
  }

  handleLogin = (e: SyntheticEvent<HTMLButtonElement>) => {
    if (e) {
      e.preventDefault();
    }
    const { usernameValue, passwordValue, nameValue } = this.state;
    const { codigoCupom } = this.props;
    this.props.clear();

    if (usernameValue && passwordValue) {
      if (this.state.viewCadastro) {
        authenticationService
          .cadastroSimples({
            name: nameValue,
            email: usernameValue,
            password: passwordValue,
            confirmPassword: passwordValue,
            codigoCupom: codigoCupom,
          })
          .then((response) => {
            this.props.login(usernameValue, passwordValue);
          })
          .catch(() => {
            this.props.error('Não foi possível criar o cadastro.');
          });
      } else {
        this.props.login(usernameValue, passwordValue);
      }
    } else {
      this.props.clear();
      this.props.error('Informe o Usuário e Senha');
    }
  };

  handleChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    this.setState({ [name]: value });
  };

  componentWillMount() {}

  componentDidMount() {}

  handleConfirmEmail = (id: number) => {
    this.props.clear();

    if (id) {
      this.props.loading(true);

      let entity = {
        key: id,
      };

      /* return passwordRecoverService.confirm(entity).then(
        response => {
          let json = response.data;
          this.props.success({
            message:
              'E-mail confirmado com sucesso. Efetue login para concluir seu cadastro.'
          });
          this.props.loading(false);
          this.goToLocaltion('#sectionLogin');
        },
        error => {
          if (error.response.status === 404) {
            this.props.error('E-mail já foi confirmado, efetue login.');
          } else {
            this.props.error(
              'Não foi possível confirmar E-mail, tente mais tarde.'
            );
          }
          this.goToLocaltion('#sectionLogin');
          this.props.loading(false);
        }
      );*/
    }
  };

  fieldStateChanged = function(field) {
    return function(state) {
      this.setState({
        [field]: state.errors.length === 0,
        [field + 'Value']: state.value,
      });
    }.bind(this);
  }.bind(this);

  emailChanged = this.fieldStateChanged('email');
  usernameChanged = this.fieldStateChanged('username');

  passwordChanged = this.fieldStateChanged('password');
  nomeChanged = this.fieldStateChanged('name');
  abreTeste = () => {
    console.log('Teste');
    this.props.history.push('/appTeste');
    console.log(
      'Caminho atual depois do push:',
      this.props.history.location.pathname
    );
  };
  render() {
    const { loggedIn, user, ...otherProps } = this.props;
    const { username, password } = this.state;
    const formValidated = username && password;

    if (loggedIn && isSudo()) {
      return <Redirect to={{ pathname: '/pedidos' }} />;
    } else if (loggedIn && !user.cliente) {
      return <Redirect to={{ pathname: '/dashboard' }} />;
    } else if (loggedIn && !isPontoAtendimento()) {
      return <Redirect to={{ pathname: '/pedidos' }} />;
    } else if (loggedIn) {
      return <Redirect to={{ pathname: '/pedidoEmMapa' }} />;
    }

    return (
      <React.Fragment>
        <BodyWhite />
        <Toast />

        <section
          id="sectionLogin"
          className={`${
            this.state.viewCadastro ? 'back-index' : 'back-entrar'
          }`}
        >
          <Toast />
          <div className="container-fluid d-flex align-items-center logo-container">
            <div className="col-12 offset-sm-4 col-sm-4 d-flex flex-column align-items-center pt-4"></div>
          </div>
          <div className="container-fluid min-vh-100 d-flex flex-column flex-sm-row align-items-center">
            <div className="col-12 col-sm-3 text-center p-5">
              <div className="logo">
                <div className="logoMarca" onClick={this.abreTeste}>
                  {/* Abrir Iframe */}
                </div>
              </div>
            </div>

            <div className="border-sm-left col-12 offset-sm-1 col-sm-4 d-flex flex-column align-items-center">
              <form className="index_form" onSubmit={this.handleLogin}>
                {this.state.viewCadastro && (
                  <FormField
                    fieldId="name"
                    label="Nome"
                    placeholder="Insira seu Nome"
                    onStateChanged={this.nomeChanged}
                    required={true}
                    {...otherProps}
                  />
                )}
                <FormField
                  fieldId="username"
                  label="E-mail ou nome de usuário"
                  placeholder="Insira seu e-mail ou nome de usuário"
                  onStateChanged={this.usernameChanged}
                  required
                  autoComplete="new-email"
                  {...otherProps}
                />
                <PasswordField
                  showStrength={this.state.viewCadastro}
                  fieldId="password"
                  label="Senha"
                  placeholder="Insira sua senha"
                  onStateChanged={this.passwordChanged}
                  thresholdLength={7}
                  minStrength={2}
                  required
                  {...otherProps}
                />
                {!this.state.viewCadastro && (
                  <React.Fragment>
                    <div className="mb-2 link"></div>
                    <button
                      type="submit"
                      disabled={!formValidated}
                      className="float-right btn btn-sm btn-primary mb-4"
                    >
                      Acessar
                    </button>
                  </React.Fragment>
                )}
                {this.state.viewCadastro && (
                  <button
                    type="button"
                    onClick={this.validaConta}
                    disabled={!formValidated}
                    className="float-right btn btn-sm btn-primary mb-4"
                  >
                    Criar conta
                  </button>
                )}
              </form>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn, user } = state.authentication;
  const { alert } = state;
  const { messages } = state.fieldMessage;
  const { codigoCupom } = state.postoAutorizado;

  return {
    loggedIn,
    alert,
    messages,
    codigoCupom,
    user,
  };
}

const mapDispatch = ({
  alert: { error, clear, success },
  authentication: { login, loggedIn, logoff },
  load: { loading },
}) => ({
  error: (message, code) => error({ message, code }),
  clear: () => clear(),
  success: (msg) => success(msg),
  login: (user, password) => login({ user, password }),
  loading: (load: boolean) => loading({ load }),
  logoff: () => logoff(),
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatch
  )(IndexContent)
);
